<template>
  <app-panel
    class="hidden lg:block"
    data-cy-application
    suptitle="Prochain événement"
    :title="formattedDate"
  >
    <template #subtitle>
      <div class="flex flex-wrap gap-1">
        <app-chip v-if="formattedTime" class="bg-gray-50" size="small">
          {{ formattedTime }}
        </app-chip>

        <app-chip v-if="event.place" class="bg-gray-50" size="small">
          {{ event.place.address.city }},
          {{ event.place.address.zip_code }}
        </app-chip>

        <course-online-type-chip
          v-else-if="event.is_online"
          class="!bg-gray-50 !text-black"
          size="small"
        />
      </div>
    </template>

    <template #footer>
      <event-application-cta size="lg" v-bind="ctaBindings" />
    </template>
  </app-panel>

  <teleport to="body">
    <app-bottom-sheet class="lg:hidden">
      <event-application-cta size="lg" v-bind="ctaBindings" />

      <p class="text-subtle mt-2 text-center text-sm">
        Prochain événement le <strong>{{ formattedDate }}</strong>
      </p>
    </app-bottom-sheet>
  </teleport>
</template>

<script lang="ts" setup>
import { useEventApplication } from "~/business-areas/event/composables/event-application.hook";
import type { EventView } from "~/business-areas/event/composables/event-view.hook";

const properties = defineProps<{
  event: EventView;
}>();

const { formattedDate, formattedTime } = useCourseSessionInfo(properties.event);
const { ctaBindings } = useEventApplication(properties.event);
</script>
